import React from "react";

import ActionDetailDrawer from "../../ActionDetailDrawer";
import ControlDetailDrawer from "../../ControlDetailDrawer";
import IncidentDetailDrawer from "../../IncidentDetailDrawer";
import RiskDetailDrawer from "../../RiskDetailDrawer";
import KpiDetailDrawer from "../../components/kpi/KpiDetailDrawer";
import AuditUniverseDetailDrawer from "../../pages/audit/AuditUniverseDetailDrawer";
import AuditDetailDrawer from "../../pages/audit/AuditDetailDrawer";
import TenantPolicyDetailDrawer from "../../pages/catalog/TenantPolicyDetailDrawer";

export function supportsPinnedItemDrawer(itemType) {
  return ["risk", "control", "action", "incident", "tenant_policy", "audit_engagement", "audit_universe", "kpi"].includes(itemType);
}

export default function PinnedItemDetailDrawer({ item, onClose, onOpenFullPage }) {
  if (!item || !supportsPinnedItemDrawer(item.item_type)) return null;

  switch (item.item_type) {
    case "risk":
      return <RiskDetailDrawer riskId={item.item_id} onClose={onClose} />;
    case "control":
      return <ControlDetailDrawer controlId={item.item_id} onClose={onClose} />;
    case "action":
      return <ActionDetailDrawer actionId={item.item_id} onClose={onClose} onOpenFullPage={onOpenFullPage} />;
    case "incident":
      return <IncidentDetailDrawer incidentId={item.item_id} onClose={onClose} onOpenFullPage={onOpenFullPage} />;
    case "tenant_policy":
      return <TenantPolicyDetailDrawer tenantPolicyId={item.item_id} onClose={onClose} />;
    case "audit_engagement":
      return <AuditDetailDrawer auditId={item.item_id} onClose={onClose} onOpenFull={onOpenFullPage} />;
    case "audit_universe":
      return <AuditUniverseDetailDrawer auditUniverseId={item.item_id} onClose={onClose} />;
    case "kpi":
      return <KpiDetailDrawer kpiId={item.item_id} onClose={onClose} />;
    default:
      return null;
  }
}
